import PaymentStepsAccordion, { PaymentProcess } from "@components/integration/PaymentStepsAccordian";
import PaymentStepsCard, { PaymentSectionDataProps } from "@components/integration/PaymentStepsCard";
import AwardsSection from "@components/new-ui/AwardsSection";
import CaseStudyFeatureSection, { Feature } from "@components/new-ui/CaseStudyFeatureSection";
import ClientLogos, { LogoObject } from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FAQSection, { FAQSectionProps } from "@components/new-ui/FAQSection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import ProductSection, { Product } from "@components/new-ui/IndustriesSection/ProductSection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import { GoArrowUpRight } from "react-icons/go";

interface PaymentGateWay {
    icon: string;
    title: string;
    descritpion: string;
    externalLink: string;
    subTitle: string;
}

const herosectionData: HerosectionProps = {
    chipTitle: "INTEGRATION",
    title: (
        <h1 className="md:text-7xl text-5xl mb-12 font-bold text-white" style={{ fontFamily: "Degular Variable" }}>
            WhatsApp <br />
            e-commerce integration: Sell smarter, engage better
        </h1>
    ),
    description: "Make WhatsApp your most powerful sales channel. Provide real-time support and boost conversions with Gallabox’s WhatsApp e-commerce integration.",
    primaryButtonText: "Start your free trial now",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/hero-image.png",
    backgroundColor: true,
};

const paymentGateWayData: PaymentGateWay[] = [
    {
        icon: "https://assets.gallabox.com/gb-home/integrations/ecommerce/shopify.svg",
        title: "Shopify",
        subTitle: "D2C",
        descritpion: "Integrate Shopify with Gallabox to ease your e-commerce experience.",
        externalLink: "https://gallabox.com/whatsapp-integrations/shopify",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/integrations/ecommerce/shopflo.svg",
        title: "Shopflo",
        subTitle: "D2C",
        descritpion: "Connect Shopflo with Gallabox to identify ready-to-buy customers.",
        externalLink: "https://docs.gallabox.com/integration/e-commerce-platforms/shopflo",
    },
];

const featureInfo1: FeatureInfo = {
    mainTitle: "Seamless shopping",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/tantric-design.png",
    featureInfoList: ["Product browsing directly on WhatsApp", "Optimised product catalogs", "Instant order updates"],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "AI-powered chatbots",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/stay-cay.png",
    description: "Use GenAI to your advantage and decrease sales cycles by a long shot",
    featureInfoList: ["Order processing and enquiry handling 24/7", "Follow-up nudges to encourage buying", "Targeted product recommendations"],
};

const featureInfo3: FeatureInfo = {
    mainTitle: "Personalized marketing",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/personalised-marketing.png",
    featureInfoList: ["Exclusive offers and restock alerts", "Identification and targeting of ready-to-buy customers", "Abandoned cart recovery to win back lost sales"],
};

const featureInfo4: FeatureInfo = {
    mainTitle: "Integral integrations",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/integral.png",
    featureInfoList: ["CRM integrations for seamless customer service", "Payment integrations for easy payment processing", "Logistics integrations to ensure product delivery"],
};

const productCardData: Array<Product> = [
    {
        title: "Enhanced customer conversations",
        description: "Send order updates, product recommendations, etc., with rich media [images, videos, etc.]",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/profile-image.svg",
        headerBackground: true,
    },
    {
        title: "Localized communication",
        description: "Use language preferences to personalize messages to customers across the world.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/group-chat.svg",
        headerBackground: true,
    },
    {
        title: "Conversational Commerce",
        description: "Provide product consultations through live or automated chats.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/bot.svg",
        headerBackground: true,
    },
    {
        title: "Customer Support and Feedback",
        description: "Ask for feedback or reviews after purchase to improve service and build trust.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/customer-supporter.svg",
        headerBackground: true,
    },
];

const caseStudyFeatureCardData: Array<Feature> = [
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/bucket-studio.png",
        chiptitle: "E-COMMERCE",
        title: "Why Thread Bucket Studio chose Gallabox over Wati for seamless team communication",
        statsInfoData: [
            { percentage: "68%", label: "Higher business growth" },
            { percentage: "50%", label: "Rise in employee productivity" },
            { percentage: "30%", label: "Growth in customer base" },
        ],
        url: "https://gallabox.com/case-study/thread-bucket-studio",
        cardColor: true,
    },
];

const defaultFAQData: FAQSectionProps = {
    title: "Got questions? Perhaps these FAQs can help!",
    faqItems: [
        {
            question: "What is WhatsApp ecommerce Integration?",
            answer: (
                <div>
                    WhatsApp Ecommerce Integration connects your online store with WhatsApp, letting you showcase products, send updates, and handle customer interactions directly
                    in chat. This streamlines the buying experience within a familiar messaging app.
                </div>
            ),
        },
        {
            question: "Can I manage customer orders and support through WhatsApp after integrating with my ecommerce site?",
            answer: (
                <>
                    Yes, definitely! You can easily manage customer orders and also provide customer support using platforms like Gallabox. Gallabox allows you to connect your
                    WhatsApp Business API with your ecommerce system, enabling automated order confirmations, delivery updates, and support interactions via WhatsApp.
                </>
            ),
        },
        {
            question: "Does WhatsApp ecommerce integration support automated order confirmations and updates?",
            answer: (
                <p>
                    Yes, Gallabox supports automated order confirmations and updates through its WhatsApp Business API integration. This feature allows businesses to automatically
                    send purchase receipts, delivery updates, and live order tracking links to customers.
                </p>
            ),
        },
        {
            question: "Can customers make purchases directly through WhatsApp after the integration?",
            answer: (
                <div>
                    Yes, once ecommerce stores are integrated with WhatsApp, customers can browse products, ask questions, and complete purchases directly in WhatsApp. It creates a
                    smooth and instant shopping experience without needing to visit your website or switch apps during the process.
                </div>
            ),
        },
        {
            question: "Is it possible to integrate WhatsApp with my inventory management system through ecommerce integration?",
            answer: (
                <div>
                    Yes, WhatsApp can be integrated with inventory management software, allowing real-time stock updates. Customers only see available products, and your backend
                    reflects changes instantly after a purchase is made through WhatsApp.
                </div>
            ),
        },
        {
            question: "Can I use WhatsApp for customer support after integrating with my ecommerce store?",
            answer: (
                <>
                    Yes, you can! Apart from integrating WhatsApp with your ecommerce store, you also have the option to integrate it with CRM platforms like Zoho CRM, HubSpot,
                    LeadSquared, etc, through platforms like Gallabox. Using this integration, you can provide efficient customer support through WhatsApp 24/7.
                </>
            ),
        },
        {
            question: "How secure is customer data during WhatsApp ecommerce transactions and communications?",
            answer: (
                <p>
                    Customer data is highly secure on WhatsApp, thanks to end-to-end encryption. When paired with trusted eCommerce platforms, all data handling and transactions
                    follow strict privacy protocols. Gallabox is compliant with SOC2 and GDPR standards, ensuring user privacy and data protection.
                </p>
            ),
        },
        {
            question: "Does WhatsApp ecommerce Integration allow for payment processing directly within the app?",
            answer: (
                <p>
                    Yes. By integrating with payment gateways like RazorPay, CashFree, Stripe, etc., payment processing can be done directly within the app. Gallabox supports such
                    seamless integrations of different apps, thus ensuring secure order checkout from WhatsApp itself.
                </p>
            ),
        },
        {
            question: "Is it possible to integrate WhatsApp with my CRM system to sync customer data and interactions?",
            answer: (
                <p>
                    Yes, you can. Through Gallabox, you can integrate WhatsApp with your CRMs like Zoho CRM, HubSpot, LeadSquared, etc. This helps to sync customer data and
                    interaction history. This ensures personalized communication and lets your sales and support teams stay updated in real time.
                </p>
            ),
        },
    ],
};

const defaultPaymentSectionData: PaymentSectionDataProps[] = [
    {
        imageUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/overview.gif",
        title: "Navigate to Integrations section",
        description: "Go to Integrations → E-commerce in the Gallabox Dashboard and select the preferred ecommerce platform.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/configuration.gif",
        title: "Enter your shop URL",
        description: "Enter your shop URL to initiate the connection with your ecommerce platform.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/configuration.gif",
        title: "Configure the Settings",
        description: "Choose your preferred WhatsApp channel and configure it.",
    },
];

const paymentStepsData: PaymentProcess = {
    title: "How to integrate Gallabox with your ecommerce store in 3 simple steps?",
    ProcessSteps: [
        {
            imageUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/overview.gif",
            title: "Navigate to Integrations section",
            description: "Go to Integrations → E-commerce in the Gallabox Dashboard and select the preferred ecommerce platform.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/overview.gif",
            title: "Enter your shop URL",
            description: "Enter your shop URL to initiate the connection with your ecommerce platform.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/overview.gif",
            title: "Configure the Settings",
            description: "Choose your preferred WhatsApp channel and configure it.",
        },
    ],
};

const clientLogosData: LogoObject[] = [
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/biotique.svg", alt: "biotique", width: 100, height: 20 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/burgerman.svg", alt: "burgerman", width: 100, height: 0 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/designer-shake.svg", alt: "designer-shake", width: 100, height: 20 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/eter.svg", alt: "eter", width: 50, height: 50 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/glen.svg", alt: "glen", width: 100, height: 20 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/hugg.svg", alt: "hugg", width: 90, height: 0 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/kumaren-silks.svg", alt: "kumaren-silks", width: 120, height: 20 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/lovegen.svg", alt: "lovegen", width: 100, height: 20 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/lux.svg", alt: "lux", width: 100, height: 20 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/royaloak.svg", alt: "royaloak", width: 100, height: 20 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/saravana-store.svg", alt: "saravana-stores", width: 120, height: 40 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/seder.svg", alt: "seder", width: 90, height: 10 },
];

const Ecommerce: React.FC = () => {
    return (
        <NewLayout
            title={"WhatsApp Ecommerce Integration for Sales & Support"}
            description={
                "Enable WhatsApp Ecommerce Integration to streamline customer communication, send real-time order updates, and improve sales conversions on your online store."
            }
            canonical={"https://gallabox.com/integrations/payment/whatsapp"}
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/integrations/ecommerce/ecommerce-og.png" }}
        >
            <Herosection herosection={herosectionData} />

            <section className="mt-20 mb-20">
                <div className="w-full">
                    <h3 className="text-base text-center font-normal py-2">Trusted by 10,000+ businesses</h3>
                    <ClientLogos logos={clientLogosData} />
                </div>
            </section>
            <section className={`${container_classname} mb-20`}>
                <h3 className="mb-5 md:text-6xl text-4xl">Why integrate your ecommerce store with WhatsApp?</h3>
                <p>With WhatsApp ecommerce integration, you can easily connect your ecommerce store with Gallabox to sell and support customers on WhatsApp.</p>

                <section className="grid md:grid-cols-3 gap-6 mt-9">
                    {paymentGateWayData.map((paymentGate, idx) => {
                        return (
                            <a className="p-5 border border-gray-200 border-solid rounded-md hover:no-underline" key={idx} href={paymentGate.externalLink}>
                                <div className="flex gap-5 mb-9">
                                    <img src={paymentGate.icon} alt="" width={64} height={64} />
                                    <div className="flex flex-col gap-1">
                                        <p>{paymentGate.title}</p>
                                        <p>{paymentGate.subTitle}</p>
                                    </div>
                                </div>
                                <p>{paymentGate.descritpion}</p>
                                <GoArrowUpRight size={20} className="mt-5 ml-auto" />
                            </a>
                        );
                    })}
                </section>
            </section>

            <section className="lg:block hidden">
                <PaymentStepsCard title={"How to integrate Gallabox with your ecommerce store in 3 simple steps?"} paymentSectionData={defaultPaymentSectionData} />
            </section>
            <PaymentStepsAccordion paymentStepsData={paymentStepsData} />

            <section>
                <FeatureInfoCard {...featureInfo1} />
                <FeatureInfoCard {...featureInfo2} />
                <FeatureInfoCard {...featureInfo3} />
                <FeatureInfoCard {...featureInfo4} />
            </section>
            <ProductSection title="Best practices for using WhatsApp ecommerce integration" productCardData={productCardData} />
            <section>
                <CaseStudyFeatureSection features={caseStudyFeatureCardData} backgroundColor={true} />
            </section>

            <FAQSection faqData={defaultFAQData} />

            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection title="Join 1000+ businesses using WhatsApp to grow their ecommerce sales!" description="Be among the first to ride the WhatsApp automation wave" />
        </NewLayout>
    );
};

export default Ecommerce;
